import { render, staticRenderFns } from "./ChargingPointDetailReviews.vue?vue&type=template&id=0c8a4ac4"
import script from "./ChargingPointDetailReviews.vue?vue&type=script&lang=js"
export * from "./ChargingPointDetailReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports